"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _immutable = require("immutable");

var _draftJs = require("draft-js");

var _reactOutsideClickHandler = _interopRequireDefault(require("react-outside-click-handler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const alias = {
  javascript: "js",
  jsx: "js"
};

function CodeSwitchContainer(props) {
  function handleClickOutside() {
    props.onClickOutside();
  }

  return _react.default.createElement(_reactOutsideClickHandler.default, {
    onOutsideClick: () => handleClickOutside()
  }, _react.default.createElement("div", {
    contentEditable: false,
    onClick: props.onClick
  }, props.children));
}

function CodeBlock(props) {
  const [isOpen, setIsOpen] = _react.default.useState(false);

  function onChange(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    const blockKey = props.block.getKey();
    const {
      getEditorState,
      setReadOnly,
      setEditorState
    } = props.blockProps;
    const editorState = getEditorState();
    const selection = editorState.getSelection();
    const language = ev.currentTarget.value;
    const blockSelection = selection.merge({
      anchorKey: blockKey,
      focusKey: blockKey
    });
    setIsOpen(false);
    let content = editorState.getCurrentContent();
    content = _draftJs.Modifier.mergeBlockData(content, blockSelection, (0, _immutable.Map)({
      language
    }));
    setReadOnly(false);

    const newEditorState = _draftJs.EditorState.push(editorState, content, "change-block-data");

    setEditorState(_draftJs.EditorState.forceSelection(newEditorState, selection));
  }

  function cancelClicks(event) {
    return event.preventDefault();
  }

  function onSelectClick(event) {
    setIsOpen(true);
    const {
      setReadOnly
    } = props.blockProps;
    event.stopPropagation();
    setReadOnly(true);
    setIsOpen(true);
  }

  function onClickOutside() {
    if (isOpen === false) return;
    setIsOpen(false);
    const {
      getEditorState,
      setReadOnly,
      setEditorState
    } = props.blockProps;
    setReadOnly(false);
    setIsOpen(false);
    const editorState = getEditorState();
    const selection = editorState.getSelection();
    setEditorState(_draftJs.EditorState.forceSelection(editorState, selection));
  }

  const {
    languages,
    renderLanguageSelect,
    getReadOnly,
    language: _language
  } = props.blockProps;
  const language = alias[_language] || _language;
  const selectedLabel = languages[language];
  const selectedValue = language;
  const options = Object.keys(languages).reduce((acc, val) => [...acc, {
    label: languages[val],
    value: val
  }], []);
  return _react.default.createElement("div", null, _react.default.createElement(_draftJs.EditorBlock, props), _react.default.createElement(CodeSwitchContainer, {
    onClickOutside: onClickOutside,
    onClick: onSelectClick
  }, !getReadOnly() && renderLanguageSelect({
    selectedLabel,
    selectedValue,
    onChange,
    options
  })));
}

var _default = CodeBlock;
exports.default = _default;